import actions from '../../actions/BenefitsSetIdentifiers'
import connectIndex from '../../lib/connectIndex'
import BulkIdentifierComponent from '../common/BulkIdentifierComponent'

export default connectIndex(
  BulkIdentifierComponent,
  'benefitsSetIdentifiers',
  actions,
  [],
  {
    indexParams: { product_line: 'hospital_indemnity' },
    redirectTo: '/hospital_indemnity_benefits/bulk'
  }
)
